import React, {useMemo, memo, useRef} from 'react';
import HighchartsReact from 'highcharts-react-official'
import Highcharts  from 'highcharts'
import _ from 'lodash'

type chartDataType = {
    categories:string[],
    series:number[]
}

const getChartOption = (chartData:chartDataType) =>{
    return(
    {
        chart: {
            type: 'column'
        },
        title: {
            text: 'Histogram'
        },
        
        xAxis: {
            categories: chartData? chartData.categories:null,
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
              text: ''
            }
        },
        plotOptions: {
            column: {
              pointPadding: 0.15,
              borderWidth: 0.9,
              groupPadding: 0,
              shadow: true
            }
        },
        series: [{
            name: 'Data',
            data:chartData.series
        }],
        credits: {
            enabled: false
        }
    })
}



const Highchart = (props:{
    data : chartDataType;
}) => {
    const chart = useRef();

    
    
    const config = useMemo(() => {
         return getChartOption(props.data);
    }, [props.data])


    return (
        <div className='chartContainer'>
            <HighchartsReact
                ref={chart}
                containerProps={{ className: "map", style: { width: "100%" } }}
                highcharts={Highcharts}
                options={config}
            />
        </div>
    )
}

export default memo(Highchart);